import { useMemo } from 'react';

import RequestCallback from './containers/RequestCallback';
import RequestResult from './containers/RequestResult';
import SelectConnectionMethod from './containers/SelectConnectionMethod';
import { useContextSelector } from './context/hooks';
import { TPopupGroupState } from './context/initialState';
import { getView } from './context/selectors';

const PopupMap: Record<TPopupGroupState, (() => JSX.Element) | null> = {
    'connect': SelectConnectionMethod,
    'callback': RequestCallback,
    'result': RequestResult,
    'none': null,
};

const ConnectDomruPopupGroup = () => {
    const view = useContextSelector(getView);

    const CurrentPopup = useMemo(() => PopupMap[view], [view]);

    if (!CurrentPopup) {
        return null;
    }

    return <CurrentPopup/>;
};

export default ConnectDomruPopupGroup;
